import fetch, { doUpload, doPost, doGet, doDelete, queryString } from '../../tools/axios'
import config from '../../tools/configs'
import { IN_APP } from '../../tools/AppConfig'

export default {
  getCMsg (type, cType, id, perPage, page, cb) {
    let _type = 'gift_id'
    if (type === 'need') {
      _type = 'need_id'
    }
    const pageParam = page != null ? `&page=${page}` : ''
    return fetch('get', `/${cType}s?type=${type}&${_type}=${id}&perPage=${perPage}${pageParam}`, {}, cb)
  },
  getRequests (giftId, search, page, perPage) {
    let bundle = {
      type: 'gift',
      gift_id: giftId,
      ...search
    }
    if (page != null) bundle.page = page
    if (perPage != null) bundle.perPage = perPage
    return doGet(`/requests${queryString(bundle)}`)
  },
  submitMsg (cType, data, cb) {
    let url = `/${cType}s${cType !== 'comment' ? '/reply' : ''}`
    return fetch('post', url, {data}, cb)
  },
  removeComment (commentId) {
    return doPost(`/comments/${commentId}/remove`)
  },
  removeChildRequestOrThank (id, cType) {
    return doDelete(`/${cType}s/${id}`)
  },
  traceItem (type, id, isTrace, cb) {
    const data = {
      [`${type}_id`]: id
    }
    return fetch('post', `/${type}s/${isTrace ? 'untrace' : 'trace'}`, {data}, cb)
  },
  getThanksWallList (cb) {
    return fetch('get', `/thanks?page=1&type=`, {}, cb)
  },
  uploadImg (file, type, cb) {
    const data = new FormData()
    data.append('file', file)
    data.append('type', type)
    return doUpload('/file/uploadImage', data, cb)
  },
  // type: gift, need, avatar, chat, resource, love
  uploadImgNew (file, type, syncS3 = 1, cb = null) {
    const data = new FormData()
    data.append('file', file)
    data.append('type', type)
    data.append('sync_s3', syncS3 ? 1 : 0)
    return doUpload('/file/uploadImg', data, cb)
  },
  sendFeedBack (data, cb) {
    return fetch('post', '/feedback', {data}, cb)
  },
  updateStatus (type, id, status, cb) {
    const data = {
      [`${type}_id`]: id,
      status
    }
    return fetch('post', `/${type}s/updateStatus`, {data}, cb)
  },
  getCurrentActivities () {
    return doGet('/reservations')
  },
  receiveCurrentActivity (id, cb) {
    return fetch('post', `/reservations/${id}/appointment`, {}, cb)
  },
  report (type, id, reason, cb) {
    const data = {
      reason
    }
    return fetch('post', `/${type}s/${id}/report`, {data}, cb)
  },
  getPalmBox (city, area, cb) {
    // 獲取某個地區的掌櫃分佈信息
    return fetch('get', `/ec/getCabinets?city=${city}&area=${area}`, {}, cb)
  },
  getIBoxes (city, district, page, perPage) {
    return doGet(`/postBoxes?city=${city}&district=${district}&page=${page}&perPage=${perPage}`)
  },
  // i 郵箱電子地圖（eMap）：建立一次性 session
  createEMapSession (returnTo) {
    return doPost('/ship/ibox/emap', {
      return_to: returnTo,
      // APP 內（Cordova）以 file:// 載入，origin 不是合法 URL，server 的 url
      // 驗證會擋下（4003）。IAB 只靠 loadstart 的 URL 字串攔截 emap_state、
      // 不會真的載入回傳頁，因此改帶部署的 web SPA origin 即可。
      mobile_host: IN_APP ? config.mobileUrl : window.location.origin
    })
  },
  // i 郵箱電子地圖（eMap）：取回選箱結果（一次性）
  consumeEMapSession (state) {
    return doPost(`/ship/ibox/emap/${encodeURIComponent(state)}/consume`, {})
  }
}
